<template>
	<NuxtLink
		:to="`/blog/${slug}/`"
		class="post-tile"
	>
		<div
			class="post-image"
			:style="`background-image:url(${imageLinkFormatter(
				sourceUrl,
				400,
				70,
				'PRODUCTION',
				'https://content.timothysykes.com'
			)})`"
		/>
		<div class="post-content">
			<div class="post-metadata mb-[8px]">
				<span>Written by {{ author }}</span>
				<span>{{ calculateReadingTime(content) }} min read</span>
			</div>
			<h3 v-html="responsiveTruncateText(title)" />
		</div>
	</NuxtLink>
</template>

<script setup lang="ts">
type Post = {
	sourceUrl: string;
	slug: string;
	title: string;
	author: string;
	content: string;
};

const { author } = defineProps<Post>();

const responsiveTruncateText = (text: string) => {
	if (process.client) {
		return window.innerWidth > 1280
			? truncateText(text, 49)
			: truncateText(text, 62);
	} else {
		return truncateText(text, 49);
	}
};
</script>

<style lang="scss" scoped>
@import "@assets/utils.scss";

.post-tile {
	border-radius: 8px;
	overflow: hidden;
	filter: drop-shadow(0px 7px 20px rgba(0, 0, 0, 0.1));
}

.post-image {
	height: 200px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	background-color: $primary-300;
	overflow: hidden;
	background-size: cover;
	background-position: center;
}

.post-metadata {
	display: flex;

	span {
		line-height: 1;
		font-family: Rubik;
		font-size: 18px;
		font-style: normal;
		font-weight: 400;
		color: $neutral-400;

		@include breakpoint(md) {
			font-size: 16px;
		}
	}

	span:first-child {
		padding-right: 8px;
		border-right: 1px solid $neutral-400;
	}

	span:last-child {
		padding-left: 8px;
	}
}

.post-content {
	padding: 8px 8px 8px;
	background-color: white;

	@include breakpoint(md) {
		min-height: 92px;
	}
}

.post-content h3 {
	color: $neutral-800;
	/* Heading/H6 */
	font-family: Fira Sans;
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: 120%;
	text-align: left;
	/* 21.6px */
}
</style>
